function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// notizie extra
	document.addEventListener("usernavready", () => {
		if (document.querySelector("#user_nav #_user_panel_container")) {
			for (const el of document.querySelectorAll("._extra-content")) {
				el.classList.add("d-none");
			}
		}
	});
});
